import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import { Userprofile } from "src/app/_models/Userprofile";
import { AdministratorService } from "src/app/_services/administrator.service";
import { CreateAdmin, CreateAdminError, CreateAdminSuccess } from "./form-administrator.actions";
import { Administrator } from "src/app/_models/Administrator";


@Injectable()
export class FormAdministratorEffects {
    constructor(
        private actions$: Actions,
        private adminService: AdministratorService
    ){}

    public createAdmin$ =  createEffect(() => {
        return this.actions$.pipe(
            ofType(CreateAdmin),
            switchMap((payload: { admin: Administrator }) => 
                this.adminService.addAdministrator$(payload.admin).pipe(
                    map((userProfile: Userprofile) => {
                        return CreateAdminSuccess({ createdAdmin: userProfile });
                    }),
                    catchError((error: any) => {
                        return of(CreateAdminError({ error: error }));
                    })
                )
            )
        )
    })
}